import { render } from "./CustomColorSelect.vue?vue&type=template&id=6b47603f&scoped=true"
import script from "./CustomColorSelect.vue?vue&type=script&lang=js"
export * from "./CustomColorSelect.vue?vue&type=script&lang=js"

import "./CustomColorSelect.vue?vue&type=style&index=0&id=6b47603f&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b47603f"]])

export default __exports__